import { acceptHMRUpdate, defineStore } from 'pinia'
import { getGenericContentSections } from '@shared/api/genericContent.js'
import { ref, computed } from 'vue'

export const useGenericContentStore = defineStore('genericContent', () => {
  const sections = ref([])
  const sectionsLoaded = ref(false)
  const initialSectionsLoaded = computed(() => sectionsLoaded.value)

  async function fetchSections (location) {
    const response = await getGenericContentSections(location)
    sections.value = Array.isArray(response.data) ? response.data : []
    sectionsLoaded.value = true
  }

  function loadInitialData () {
    // Data needed before the page is displayed should be awaited,
    // otherwise it should be loaded asynchronously in the background.
    fetchSections('homepage').catch(() => {})
  }

  const whatMembersSaySection = computed(() => sections.value?.find(section => section.name === 'what_members_say'))
  const heroImageSection = computed(() => sections.value?.find(section => section.name === 'hero_image'))
  const homepageBannersSection = computed(() => sections.value?.find(section => section.name === 'homepage_banners'))
  const homepagePlanCardSection = computed(() => sections.value?.find(section => section.name === 'homepage_plan_card'))

  return {
    sections,
    fetchSections,
    homepagePlanCardSection,
    whatMembersSaySection,
    heroImageSection,
    homepageBannersSection,
    initialSectionsLoaded,
    loadInitialData
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useGenericContentStore, import.meta.hot))
